<template>
<div>
  <div class="detailPage" v-if="showDetail">
    <!-- {{promotion}} -->
    <van-swipe @change="onChange" :autoplay="3000" class="detailImg" v-if="goodsDetail && goodsDetail.carouselImages">
      <van-swipe-item  v-for="item in goodsDetail.carouselImages" :key="item">
        <van-image :src="item + '?x-oss-process=style/750w-2'" width="100%" height="100%">
          <template v-slot:loading>
            <div class="loadingbg"></div>
          </template>
          <template v-slot:error>
            <div class="loadingbg"></div>
          </template>
        </van-image>
        <!-- <img :src="item+'?x-oss-process=style/750w-2'" alt="" width="100%" height="100%" onerror="../../assets/images/default_bg2x.png"> -->
      </van-swipe-item>
      <div class="custom-indicator" slot="indicator">
        {{ current + 1 }}/{{imgLen}}
      </div>
    </van-swipe>
    <div class="detailDefault" v-if="!goodsDetail || !goodsDetail.carouselImages"></div>
    <div class="presellinfo" >
      <div class="presellinfo-wrap">
        <div class="presellinfo-left" v-if="goodsDetail && !goodsDetail.itemPintuanInfoVo && goodsDetail.salePrice !== 0">
          <div class="detail-price">
             <!-- 新人专享价格 -->
              <gprice v-if="showNewerPrice" :price="newInfo.promotionPrice || 0" color="#fff" fsize="18px" isize="24px"></gprice>
              <gprice v-else :price="goodsDetail.salePrice || 0" color="#fff" fsize="18px" isize="28px"></gprice>
              <span v-if="goodsDetail.marketPrice && goodsDetail.marketPrice !== 0" class="original"><span class="original-rmb">¥</span>{{goodsDetail.marketPrice}}</span>
          </div>
        </div>

        <div class="presellinfo-left" v-if="goodsDetail && goodsDetail.itemPintuanInfoVo && goodsDetail.itemPintuanInfoVo.pintuanPrice !== 0">
          <div class="detail-price">
              <div class="pt_price">
                <!-- 新人专享价格 -->
                <gprice v-if="showNewerPrice" :price="newInfo.promotionPrice || 0" color="#fff" fsize="18px" isize="24px"></gprice>
                <gprice v-else :price="goodsDetail.itemPintuanInfoVo.pintuanPrice || 0" color="#fff" fsize="18px" isize="24px"></gprice>
                <img class="pt_price_img" v-if="goodsDetail.itemPintuanInfoVo && goodsDetail.itemPintuanInfoVo.pintuanPrice !== 0" src="@/assets/images/pt_icon1.png" />
              </div>
              <div  class="originalpt"><span class="original-rmb">单买价¥</span>{{goodsDetail.salePrice}}</div>
          </div>
        </div>
        <!-- 新人专享权重高 -->
        <div class="presellinfo-right" v-if="(isNewer || !isLogin) && newInfo && newUserTimes">
          <p class="jujieshu">距结束仅剩</p>
          <van-count-down :time="newUserTimes" v-if="newUserTimes" @finish="ftime('newUserTimes')">
            <template v-slot="timeData">
              <p class="presell-countdown">
                <span>{{timeData.days}}</span>天
                <span>{{timeData.hours}}</span>时
                <span>{{timeData.minutes}}</span>分
                <span>{{timeData.seconds}}</span>秒
              </p>
            </template>
          </van-count-down>
        </div>
        <div class="presellinfo-right" v-else-if="countDownTimes">
          <p class="jujieshu">距结束仅剩</p>
          <van-count-down :time="countDownTimes" v-if="countDownTimes" @finish="ftime('countDownTimes')">
            <template v-slot="timeData">
              <p class="presell-countdown">
                <span>{{timeData.days}}</span>天
                <span>{{timeData.hours}}</span>时
                <span>{{timeData.minutes}}</span>分
                <span>{{timeData.seconds}}</span>秒
              </p>
            </template>
          </van-count-down>
        </div>
      </div>
    </div>

    <div class="goods-info" v-if="goodsDetail">
      <div class="goods-info-left">
        <p class="title">{{goodsDetail.itemFullName}}
        </p>
        <p class="description">{{goodsDetail.sellPoint || ""}}</p>
      </div>
      <div class="goods-info-right" v-if="goodsDetail.receivePoint">
        <span>可得积分</span>
        <span class="score">{{goodsDetail.receivePoint}}</span>
      </div>
    </div>
    <div class="actEndTime" v-if="(isNewer || !isLogin) && newInfo && newUserTimes">
      <span class="endTimeLine">结束时间：{{newInfo.endTime | formatDate("MM月DD日 HH:mm")}}</span>
    </div>
    <div class="actEndTime" v-else-if="promotion && promotion.skuPromotion && promotion.skuPromotion.endTime">
      <span class="endTimeLine">结束时间：{{promotion.skuPromotion.endTime | formatDate("MM月DD日 HH:mm")}}</span>
      <!-- <span v-if="goods.shipmentMethod==1">提货时间：{{goodsDetail.saleActivityInfoResponse ? goodsDetail.saleActivityInfoResponse.activityTimes[0].estimatePickupTime : "" | formatDate("MM月DD日")}}</span> -->
    </div>
    <div class="tagView flex flex-between" v-if="couponList && couponList.length">
      <div class="tags">
        <van-tag class="tag" color="#FFDBD1" text-color="#FA6339" v-for="item in tagList" :key="item">{{item}}</van-tag>
      </div>
      <div class="btn" @click="showCouponList = true">
        <span class="font-16">领劵</span>
        <van-icon name="arrow" size="16"/>
      </div>
    </div>
    <div class="greyline"></div>
    <!-- 新人专享新增判断是否积分 -->
    <!--  v-if="!((isNewer || !isLogin) && newInfo && !newInfo.isIntegral)" -->
    <div class="promotion_clean" v-if="showPoint">
      本商品支持{{pointRate}}%积分抵扣
      <!-- <span class="goto"></span> -->
      <!-- <span class="promotion_info"><b class="promation_manzhe"></b>{{`${selectAttr} ${payNum}件`}}</span> -->
    </div>

    <div class="greyline"></div>
    <div class="promotion" @click="selectSpec">
      <span class="goto">已选</span>
      <span class="promotion_info"><b class="promation_manzhe"></b>{{`${selectAttr} ${payNum}件`}}</span>
    </div>

    <!-- <div class="detail_pt_module" v-if="noticeList.length>0 && goodsDetail.itemPintuanInfoVo"> -->
    <div class="detail_pt_module" v-if="noticeList.length>0">
      <div class="greyline"></div>
      <div class="pt_rule" @click="showPtListFn">
        <div class="pt_ruleLpt">{{itemAttendanceCount}}人正在拼团，可直接参团</div>
        <div class="pt_ruleR">
          <div>查看更多</div>
        </div>
      </div>

      <CollageScroll :noticeList="noticeList" @gotoJoinGroup="gotoJoinGroup"/>

      <div class="pt_rule pt_rulenobor" @click="gotoPtRule" v-if="goodsDetail && goodsDetail.itemPintuanInfoVo">
        <div class="pt_ruleL">拼团规则</div>
        <div class="pt_ruleR">
          <div>好友参团·人满发货·不满退款</div>
        </div>
      </div>
    </div>

    <div class="greyline"></div>
    <div class="promotion" @click="chooseAddrTap">
      <span class="goto">送至</span>
      <span class="promotion_info"><img class="location" src="../../assets/images/gps.png" />{{addrprovince + " " + addrcity + " " + area + " " + address}}</span>
    </div>
    <div class="greyline"></div>

    <div class="promotion" @click="promotionTap" v-if="promotion && promotion.promotionDetail && promotion.promotionDetail.length">
      <span class="goto">促销</span>
      <span class="promotion_info"><b class="promation_manzhe">[{{promotionMode[promotion.promotionDetail[0].promotionMode]}}]</b>{{promotion.promotionDetail[0].promotionMemo}}</span>
    </div>
    <div class="greyline" v-if="promotion && promotion.skuPromotion"></div>
    <div class="goods-detail">
      <p class="goods-detail-title">商品详情</p>
      <div class='goods-desc'>
            <van-image
              fit="contain"
              v-for="itemimg in goodsDesc" :key="itemimg"
              :src="itemimg+'?x-oss-process=style/750w-2'"
            >
            <template v-slot:loading>
              <div class="detailloadingbg"></div>
            </template>
            </van-image>
      </div>
    </div>
  
    <detail-foot :newUser="((isNewer || !isLogin) && newInfo && newInfo.promotionPrice && newUserTimes)?true:false" :newPrice="newInfo?(newInfo.promotionPrice || 0):0" @goOrderConfirm="goOrderConfirm" :goodsDetail="goodsDetail" :buyStatus="buyStatus" :tipMessage="tipMessage" :shopNum="shopNum" @immeBuy="immeBuy" @openGroup="openGroup" :saleSkuId="saleSkuId" :isLogin="isLogin"></detail-foot>

    <van-popup
      v-model="showPtList"
      closeable
      position="bottom"
      close-icon="close"
    >
      <div class='detail-order'>
        <div class="promation_title">
            可参与的拼单
        </div>
        <div class="address_wrap">
          <div class="pt_scroll_con">
            <CollageItem v-for="(item,index) in popCollage" :item="item" :key="index" v-on:gotoJoinGroup="gotoJoinGroup"/>
          </div>
          <div class="pt_scroll_count">
          仅显示10个当前正在拼团的人
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showAddr"
      closeable
      position="bottom"
      close-icon="close"
    >
      <div class='detail-order'>
        <div class="promation_title">
            选择地址
        </div>
        <div class="address_wrap">
          <div class="promotionaddr_pop">
            <van-radio-group v-model="selAddr" class="selAddrRadio" @change="changeAddr">
              <van-radio class="vanradio" checked-color="#FA6339" @click="radioTap" :name="item.receiverId" v-for="item in addrList" :key="item.receiverId">{{item.provinceName+item.cityName+item.countyName+item.address}}</van-radio>
            </van-radio-group>
          </div>
        </div>

        <div>
          <div class="picker">
            <div class="chooseArea" @click="popAreaList">选择其他区域地址</div>
          </div>
      </div>

      </div>
    </van-popup>

    <van-popup
      v-model="showPromation"
      closeable
      position="bottom"
      close-icon="close"
    >
      <div class='detail-order'>
        <div class="promation_title">
            促销
        </div>
        <div class="promotion_con" v-if="promotion">
          <div class='promotion_pop' v-for="item in promotion.promotionDetail" :key="item.promotionId">
            <span class="allzhe">[{{promotionMode[item.promotionMode]}}]</span>
            <span class="promotion_des">{{item.promotionMemo}}</span>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showGoodspe"
      closeable
      position="bottom"
      close-icon="close"

    >
      <specPop ref="specpop" :newPrice="newInfo && newUserTimes?(newInfo.promotionPrice || 0):0" 
       :isNewer="isNewer && newUserTimes ? true : false"
       :changeDisabled="((isNewer || !isLogin) && newInfo && newInfo.promotionPrice && newUserTimes)?true:false"
       v-if="goodsDetail && showGoodspe" :isitemPintuanInfoVo="isitemPintuanInfoVo" :saleSkuQuantity="saleSkuQuantity" 
       :skuAttrs="skuAttrs" :spuAttrs="spuAttrs" :goodsDetail="goodsDetail" :packAttr="packAttr" @changeSku="changeSku" 
       @confirmSpec="confirmSpec" :buyStatus="buyStatus" :defaultId="saleSkuId" @changeNum="changeNum" :initNum="payNum" 
       :isShop="isShopBtn" :type="popType" ></specPop>
    </van-popup>
    <van-popup
      v-model="showAreaList"
      position="bottom"
    >
      <van-area :area-list="areaList" :columns-num="3" @confirm="confirmArea" @cancel="cancleArea"/>
    </van-popup>

    <!-- <div :class="['move_view', moveView]" @click="chooseShare" v-if="$platform && $platform === 'miniProgram'"> -->
    <div :class="['move_view', moveView]" @click="chooseShare" v-if="$route.query.minit">
        分享好友一起买
    </div>

    <RollingBall :balls="balls" :dropBalls="dropBalls"/>
    <!-- 优惠券列表 -->
    <van-popup
      v-model="showCouponList"
      round
      position="bottom"
      style="height: 60%; padding-top: 4px;"
    >
      <div class="title font-16">可用优惠券</div>
      <van-list>
        <template v-for="item in couponList">
          <!-- @onUse="useCoupon" @onGet="getCoupon" :radioValue.sync="radioCheck" -->
          <coupon-item :showUse="false" :item="item" :key="item.id" @onGet="getCoupon" ></coupon-item>
        </template>
      </van-list>
      <div class="div-60"></div>
      <div class="bottom-div">
        <div class="bottom-btn" @click="showCouponList=false">完成</div>
      </div>
    </van-popup>
  </div>
  <expireGood v-if="!showDetail"></expireGood>
  </div>
</template>
<script>
import specPop from './specPop'
import RollingBall from './RollingBall'
import CollageScroll from './CollageScroll'
import CollageItem from './CollageItem'
import { mapState,mapActions } from 'vuex'
import {area} from '../../config/area.js'
import {precision} from '../../plugins/precision'
import gprice from '../../components/gprice'
import expireGood from "../expireGood"
import DetailFoot from './DetailFoot'
import defaultImg from "@/assets/images/default.png"
import couponItem from '@/components/couponItem'
let interval;
export default {
    name: '',
    components:{
      specPop,
      gprice,
      expireGood,
      RollingBall,
      CollageScroll,
      CollageItem,
      'detail-foot': DetailFoot,
      couponItem
    },
    data () {
        return {
          popType: "shop",
          group: null,
          isCollage: false,
          current: 0,
          goodsDetail:null,
          goods:{},
          countDownTimes: 0,
          addrprovince: "北京市", //省
          addrcity: "市辖区", // 市
          area: "朝阳区", // 区
          address: "",
          showAddr:false,
          showPromation:false,
          showAreaList:false,
          promotion:{},
          goodsDesc:[],
          areaList:{},
          showGoodspe:false,
          isSale:false, // 商品是否可售
          activityStatus: false,
          goodsInventory: 1, // 商品库存
          addrList:[], // 收货地址
          selAddr:"", //当前收货地址
          moveView:"",
          isShopBtn: true,

          itemSku:null,
          packAttr:[],
          saleSkuId: "",
          skuAttrs: [],
          spuAttrs: [],
          selectAttr: "", // 已选属性
          selectAttrId: "", //已选属性id
          payNum: 1, // 已选数量
          saleSkuQuantity: 0, //库存
          saleSkuStatus: 0,
          tipMessage: "",
          showDetail: true,
          promotionMode: {
            "WEIYUAN": "抢购",
            "MANJIAN": "满减",
            "MANZHE": "满折",
          },
          defaultImg: defaultImg,
          balls: [
            {
              show: false
            },{
              show: false
            },{
              show: false
            },{
              show: false
            },{
              show: false
            }
          ],
          dropBalls: [],
          beforeDetail: "",
          noticeList: [],
          animate:false,
          intNum: undefined,
          showPtList:false,
          itemAttendanceCount: 0, //商品拼团人数
          popCollage: [],
          isitemPintuanInfoVo: false,
          isNewer:true,// 是否新人
          newUserTimes:0, //新人专享结束时间
          newInfo:null,//新人活动信息
          couponList:[],//优惠券列表
          tagList:[], // 优惠券标签列表
          loading:false,
          finish:true,
          showCouponList:false,
          pointRate:0
        }
    },
    computed: {
      top () {
        return -this.activeIndex * 48 + 'px'
      },
      // optionSingleHeightTime () {
      //   return {
      //     step: 1, // 数值越大速度滚动越快
      //     limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
      //     openWatch: true, // 开启数据实时监控刷新dom
      //     singleHeight: 48, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
      //     waitTime: 2500 // 单步运动停止的时间(默认值1000ms)
      //   }
      // },
      imgLen: function(){
        if(!this.goodsDetail){
          return 0
        }
        return this.goodsDetail.carouselImages ? this.goodsDetail.carouselImages.length : 0
      },
      ...mapState({
          isLogin: (state)=> state.user.isLogin,
          shopNum: (state)=> state.shopcar.shopNum,
      }),
      buyStatus: function(){
        // console.log(!this.isSale , !this.saleSkuStatus , this.saleSkuQuantity)
        if(!this.isSale || !this.saleSkuStatus || this.saleSkuQuantity < 1){
          return false
        }
        return true
      },
      showPoint(){
        return !this.isLogin || !this.isNewer || !this.newInfo || (this.isNewer && this.newInfo && this.newInfo.isIntegral>0)
      },
      showNewerPrice(){
        return (this.isNewer || !this.isLogin) && this.newInfo && this.newUserTimes>0 && this.newInfo.promotionPrice
      }
    },
    created(){
      if(this.$route.query.minit && this.$route.query.locations){
        let addrStr = JSON.parse(this.$route.query.locations)
        if(addrStr){
          this.addrprovince = addrStr.addrprovince || "北京市";
          this.addrcity = addrStr.addrcity || "市辖区";
          this.area = addrStr.area || "朝阳区";
          if(this.addrprovince === this.addrcity){
            this.addrcity = "市辖区"
          }
        }
      }
    },
    async mounted() {
      setTimeout(() => {
          this.moveView = "moveView";
      }, 1500)
      await this.checkLogin()
      // this.$toast(this.isLogin)
      if(this.isLogin){
        // 检查是否新人
        await this.userCheck()
      }
      let query = this.$route.query;
      if(query.jhd){
        localStorage.setItem(this.$env+"curl","/activity")
      }
      if(query.m){
        localStorage.setItem(this.$env+"curl","/share")
      }
      localStorage.setItem(this.$env+'detailPath',JSON.stringify(query))
      let saleSkuId = query.saleSkuId || query.goodsId || "0"
      let params = {
        itemId: saleSkuId
      }
      this.saleSkuId = parseInt(saleSkuId);

      this.getDetail(params,()=>{
        this.beforeDetail = localStorage.getItem(this.$env+"enterDetail")
        let initTime = this.initTime;
        if(this.goodsDetail && this.goodsDetail.itemPintuanInfoVo){
          this.getCollageItem()
        }
        this.goodsDetail && this.$service.getStatisCommon("evn_open_page",{
          initTime: initTime,
          ed:{
            categoryId: this.goodsDetail.itemPintuanInfoVo ? 'group' : '',
            type: this.goodsDetail.itemPintuanInfoVo ? 'group' : '',
            saleSkuId: saleSkuId,
            ...params
          }
        },this.beforeDetail);

      });
      this.areaList = area;



      this.getAreaSel()

      this.$store.dispatch("order/setAddrType","")

      this.$store.dispatch("user/checkLogin").then(res=>{
        if(this.isLogin){
          this.getMemberReceiverList()
          this.getShopCarNum();
        }
      })
      let initTime = this.initTime
      this.$service.getStatisCommon("evn_dom_finish",{
        initTime: initTime,
        ed:{
          categoryId:this.$route.query.categoryId||'',
          ...params,
        }
      });
    },
    destroyed() {
      clearInterval(interval)
      interval = null;
      clearInterval(this.intNum);
      this.intNum=null;
    },
    methods: {
      ...mapActions('user',['checkNewer','checkLogin']),
      // 检查新人逻辑
      userCheck:function(){
        return new Promise((resolve,reject)=>{
          if(!this.isLogin) {
            resolve(true)
          }
          this.checkNewer().then(res=>{
            // this.isNewer = true //test
            this.isNewer = res.result
            resolve(res.result)
          }).catch(e=>{
            reject(e)
          })
        })
      },
      /**
       * @description 检查商品是否有优惠券
       * @param itemId 商品itemid
       * @param couponProductEnum 类型 ITEM_PAGE
       */
      checkCoupon:function(){
        const param = {
          itemId:this.saleSkuId,
          couponProductEnum:'ITEM_PAGE'
        }
        this.$service.usefulList(param).then(res=>{
          // console.log(res)
          const tagList = []
          if(res.result && res.result.couponInfoList.length){
            this.couponList = res.result.couponInfoList
            this.couponList.map(item=>{
              const text = `满${item.fullPrice}减${item.subPrice}`
              tagList.push(text)
            })
            this.tagList = tagList
          }
        })
      },
      /**
       * @description 获取优惠券
       */
      getCoupon:function(couponInfoId){
        this.$toast.loading()
        this.$service.getCoupon({couponInfoId:couponInfoId}).then(res=>{
          // console.log(res)
          this.$toast.clear()
          if(res.result.status != 200){
            this.$toast(res.result.message)
          }else{
            this.$toast.success('领取成功')
            this.$nextTick(()=>{
              this.checkCoupon()
            })
          }
        })
      },
      openGroup(){//我要开团，选择规格后，跳转至提交订单页
        if(!this.isLogin){
          if(this.$platform === "miniProgram"){
            let fullPath = this.$route.fullPath;
            let path = `/pages/detail/detail`
            this.$wx.miniProgram.navigateTo({
              url: "/pages/login/login?pagefrom="+path+"&"+fullPath.split('?')[1]
            })
          }else{
            this.$router.push({ path: `/login`})
          }
          return
        }
        this.showGoodspe = true;
        this.isShopBtn = false
        this.popType = "start"
      },
      gotoJoinGroup(group){
        this.$service.getStatisCommon("evn_detail_clickjoin",{
          md: '拼团',
          ed:{
            saleSkuId: this.saleSkuId,
            categoryId: 'group',
            type: 'group',
            groupId: group.participantId
          }
        });
        if(!this.isLogin){
          if(this.$platform === "miniProgram"){
            let fullPath = this.$route.fullPath;
            let path = `/pages/detail/detail`
            this.$wx.miniProgram.navigateTo({
              url: "/pages/login/login?pagefrom="+path+"&"+fullPath.split('?')[1]
            })
          }else{
            this.$router.push({ path: `/login`})
          }
          return
        }

        this.group = group;
        this.showGoodspe = true;
        this.isShopBtn = false
        this.popType = 'join'


        // return;

        // this.$router.push({ path: `/ptDetail`})
        //校验该团是否已锁定或已成团,若是则跳转至拼团详情的“拼团结束”状态
        //否则若可参团，则在该页弹出规格选择弹窗，选择规格后跳转至提交订单页；
      },

      gotoPtRule(){
        let pageUrl = process.env.VUE_APP_WEBVIEW_URL + "/o2o_help_center/ptrule.html"
        this.$router.push({path: '/outerPage',query:{pageUrl:pageUrl}})
      },

      onChange(index) {
        this.current = index;
      },

      async getCollageItem(){
        let params = {
          itemId: this.saleSkuId,
          page: 1,
          pageSize: 10
        }
        let res = await this.$service.getCollageItem(params);
        this.noticeList = res.result.pintuanInfoVoList || [];
        this.popCollage = JSON.parse(JSON.stringify(res.result.pintuanInfoVoList)) || [];
        this.itemAttendanceCount = res.result.itemAttendanceCount || 0;

      },

      async getMemberReceiverList(){
        let memberId = localStorage.getItem(this.$env+"memberId");
        let res = await this.$service.getMemberReceiverList({params:{memberId:memberId}})
        this.addrList = res;
      },
      async getSaleInventory(params){
        try{
          let res = await this.$service.getSaleInventory(params);
        }catch(e){
          console.log(e)
        }
      },
      async getAreaSel(){
        try{
          let params =  {
            goodsId: this.saleSkuId,
            province: this.addrprovince,
            city: this.addrcity,
            area: this.area,
          }
          let res = await this.$service.isAreaSel(params)
          if(res.status === 200){
            this.isSale = true
            if(this.tipMessage === "商品暂不支持配送至该地址"){
              this.tipMessage = ""
            }
          }else{
            this.tipMessage = "商品暂不支持配送至该地址"
            this.isSale = false
          }
        }catch(e){
          this.isSale = false
          if(e !== 'neterror'){
            this.tipMessage = "商品暂不支持配送至该地址"
          }
        }
      },

      async getShopCarNum(){
        try{
          let res = await this.$service.getShopCarNum();
          let shopNum= 0;
          if(res && res.status==200){
            if(res.result>99){
              shopNum="99+";
            }else{
              shopNum=res.result;
            }
            this.$store.dispatch("shopcar/updShopCarNums",shopNum)
          }
          // this.$service.getStatisCommon("evn_close_page",{
          //   saleSkuId: this.saleSkuId
          // },this.beforeDetail);
        }catch(e){
          console.log(e)
        }

      },
      async getDetail(params,callback){
        this.tipMessage = ""
         try{
          let res = await this.$service.getDetail(params)
          // this.itemSku = result.item
          if(res.status === 400){
            this.showDetail = false;
            return
          }
          let result = res.result;
          this.goodsDetail = result.item;
          this.newInfo = result.itemNewUserExclusiveVo || null
          this.pointRate = parseInt(result.pointRate)
          if(this.isNewer && this.newInfo){
            // 是新人，并且是新人商品
            if(this.newInfo.isCoupon == 1){
              this.checkCoupon()
            }
          }else if(!this.isNewer || !this.newInfo){
            this.checkCoupon()
          }
          this.skuAttrs = result.skuAttrs
          this.spuAttrs = result.spuAtrrs
          // this.cartNum = result.cartNum || 0
          this.promotion = result.promotion;
          this.packAttr = result.itemPackSpecificationList
          // return

          if(result.promotion && result.promotion.skuPromotion && result.promotion.skuPromotion.leadTime){
            this.countDownTimes = parseInt(result.promotion.skuPromotion.leadTime*1000);
          }else if(result.item.itemPintuanInfoVo && result.item.itemPintuanInfoVo.pintuanEndTime){
            this.countDownTimes = parseInt(result.item.itemPintuanInfoVo.pintuanEndTime);
          }else{
            this.countDownTimes = 0;
          }
          // 新人专享
          if(result.itemNewUserExclusiveVo && result.itemNewUserExclusiveVo.endTime && result.itemNewUserExclusiveVo.promotionPrice){
            this.newUserTimes = parseInt(new Date(result.itemNewUserExclusiveVo.endTime).getTime()-new Date().getTime());
          }else{
            this.newUserTimes = 0
          }
          // 开启拼团
          // result.item.itemPintuanInfoVo = {name: 123}

          this.isitemPintuanInfoVo = !!result.item.itemPintuanInfoVo
          if(!result.item){
            return
          }

          this.selectAttr = result.item.packSpecification;
          this.saleSkuStatus = result.item.saleState;
          if(result.item && !result.item.saleState){
            this.tipMessage = "该商品已下架，看看其他商品吧~"
          }
          this.saleSkuQuantity = result.item.inventory > 99 ? 99 : result.item.inventory;
          if(this.saleSkuQuantity < 1){
            this.tipMessage = "该商品暂时无货，看看其他商品吧~"
          }
          this.goodsDesc = result.item ? result.item.detailImages : [];
        }catch(e){
          this.tipMessage = ""
          if(e === 'neterror'){
            this.tipMessage = "网络连接失败,请检查您的网络"
          }
        }
        callback && callback()
      },



      async changeSku(skuid){
        if(skuid === "nosku"){
          return
        }
        // 检查是否新人
        await this.userCheck()
        this.saleSkuId = skuid;
        // console.log('---',this.saleSkuId)
        this.getDetail({itemId:skuid},()=>{
          if(this.goodsDetail && this.goodsDetail.itemPintuanInfoVo){
            this.getCollageItem()
          }else{
            this.noticeList =  [];
            this.popCollage =  [];
            this.itemAttendanceCount = 0
          }
        });
        this.getAreaSel()
        this.$service.getStatisCommon("evn_change_sku",{ed:{
          "saleSkuId":skuid
        }},this.beforeDetail);
      },

      changeNum(num){
        this.payNum = num
      },
      showPtListFn(){
        this.showPtList=true;
      },
      chooseAddrTap(){
        this.showAddr = true;
      },
      changeAddr(){
        let addr = this.addrList.filter(item => {
          if(item.receiverId === this.selAddr){
            return item
          }
        })
        if(addr.length){
          this.addrprovince = addr[0].provinceName;
          this.addrcity = addr[0].cityName;
          this.area = addr[0].countyName
          this.address = addr[0].address
        }
        this.getAreaSel()

      },
      radioTap(){
        this.showAddr = false;
        this.changeAddr()
      },
      promotionTap(){
        this.showPromation = true
      },
      popAreaList(){
        this.showAreaList = true;
      },
      confirmArea(arr){
        this.addrprovince = arr[0].name;
        this.addrcity = arr[1].name
        this.area = arr[2].name
        this.address = ""
        this.getAreaSel();
        this.showAreaList = false;
        this.showAddr = false;
      },
      cancleArea(){
        this.showAreaList = false;
      },
      async immeBuy(){
        if(!this.buyStatus){
          return
        }
        if(!this.isLogin){
          if(this.$platform === "miniProgram"){
            let fullPath = this.$route.fullPath;
            let path = `/pages/detail/detail`
            this.$wx.miniProgram.navigateTo({
              url: "/pages/login/login?pagefrom="+path+"&"+fullPath.split('?')[1]
            })
          }else{
            this.$router.push({ path: `/login`})
          }
          return
        }

        this.showGoodspe = true;
        this.isShopBtn = true
        this.popType = "shop"
      },
      selectSpec(){
        this.showGoodspe = true;
        this.isShopBtn = true
        this.popType = "shop"
      },
      confirmSpec(selectAttr,selectAttrId,payNum,collageType){
        if(collageType === "shop"){
          this.addCart(selectAttr,selectAttrId,payNum)
        }
        if(collageType === "join"){
          this.joinCollage(payNum)
        }
        if(collageType === "start"){
          this.startCollage(payNum)
        }
        if(collageType === "newer"){
          this.goOrderConfirm(true)
        }
      },
      joinCollage(payNum){
        let params = {
          pintuanActivityId: this.group.pintuanActivityId,
          pintuanId: this.group.pintuanId,
          itemQuantity: payNum,
          itemId: this.saleSkuId,
          merchantSkuId: this.group.merchantSkuId,
          itemName: this.goodsDetail.itemFullName,
          salePrice: this.goodsDetail.salePrice,
          participantId: localStorage.getItem(this.$env+"memberId"),
          pintuanPrice: this.goodsDetail.itemPintuanInfoVo.pintuanPrice
        }

        this.$service.joinCollage(params).then((res)=>{
          console.log('res',res)
          if(res.status === 200){
            let pintuanId = this.group.pintuanId;
            this.$router.push({ path: `/orderConfirm`, query:{pintuanId:pintuanId,itemId: this.saleSkuId,collageType:"join"}})
            // let params = {
            //   urlstr:"orderConfirm"
            // }
            // let origin = (this.origin === "detail")
            // this.$navigateTo("orderConfirm",params,origin)
          }else{
            this.$toast(res.message)
          }
        }).catch(()=>{
          this.$toast("拼团失败")
        });
      },
      checkJoin(){
        let params = {
          pintuanActivityId: this.group.pintuanActivityId,
          pintuanId: this.group.pintuanId,
          itemId: this.group.itemId,
          merchantSkuId: this.group.merchantSkuId,
          itemName: this.goodsDetail.itemFullName,
          salePrice: this.goodsDetail.salePrice,
          participantId: localStorage.getItem(this.$env+"memberId"),
          pintuanPrice: this.goodsDetail.itemPintuanInfoVo ? this.goodsDetail.itemPintuanInfoVo.pintuanPrice : 0
        }

        this.$service.joinValidate(params).then((res)=>{
          if(res.result.status === 200 && res.result.data){
            // this.group = group;
            // this.showGoodspe = true;
            // this.isShopBtn = false
            // this.popType = 'join'
            this.joinCollage()
          }else if(res.result.status === "3000"){
            this.$router.push({ path: `/ptDetail`,query:{collageId:this.group.pintuanId}})
          }else{
            this.$toast(res.result.message)
          }
          // this.$router.push({ path: `/ptDetail`,query:{saleSkuId:this.saleSkuId}})
        }).catch(()=>{
          this.$toast("拼团失败")
        });
      },
      startCollage(payNum){
        let params = {
          pintuanActivityId: this.goodsDetail.itemPintuanInfoVo.pintuanActivityId,
          // pintuanId: this.group.pintuanId,
          itemQuantity: payNum,
          itemId: this.goodsDetail.itemId,
          merchantSkuId: this.goodsDetail.merchantSkuId,
          itemName: this.goodsDetail.itemFullName,
          salePrice: this.goodsDetail.salePrice,
          participantId: localStorage.getItem(this.$env+"memberId"),
          pintuanPrice: this.goodsDetail.itemPintuanInfoVo.pintuanPrice
        }
        this.$service.startCollage(params).then((res)=>{
          if(res.status === 200){
            let pintuanId = res.result
            this.$router.push({ path: `/orderConfirm`,query:{pintuanId:pintuanId,itemId: this.goodsDetail.itemId, collageType: "start"}})
            // let params = {
            //   urlstr:"orderConfirm"
            // }
            // let origin = (this.origin === "detail")
            // this.$navigateTo("orderConfirm",params,origin)
          }else{
            this.$toast("开团失败")
          }
        }).catch(()=>{
          this.$toast("开团失败")
        });
      },
      async addCart(selectAttr,selectAttrId,payNum){
        this.showGoodspe = false;
        this.selectAttr = selectAttr;
        this.selectAttrId = selectAttrId;
        this.payNum = payNum;

        let params = {
          skuId: this.saleSkuId,
          addPrice: this.goodsDetail.salePrice,
          quantity: this.payNum
        }
        try{
          let res = await this.$service.addCart(params);
          if(res.status === 200){
            this.getShopCarNum()

            let el = document.getElementById("immeBuy");
            this.balls.forEach(v => {
              if (!v.show) {
                v.show = true; // 当切换元素的display:block/none时，会触发vue的动画
                v.el = el; // 将触发点击事件的“+”号保定道小球对象上，方便获取动画初始时的位置
                this.dropBalls.push(v); // 取一个小球加入动画队列
                return;
              }
            });
            this.$toast("添加购物车成功")
            // this.$router.push("/shoppingCar")
          }else{
            this.$toast("添加失败，请稍后重试")
          }
        }catch(e){
          let message = e.message || "添加失败，请稍后重试"
          this.$toast(message)
        }
        this.$service.getStatisCommon("evn_add_cart",{ed:params},this.beforeDetail);
      },

      chooseShare(){
        let params = {
          skuId: this.saleSkuId,
          addPrice: this.goodsDetail.salePrice,
          quantity: this.payNum
        }
        if(this.isLogin){
          this.$service.getStatisCommon("evn_clickshare",{ed:params},this.beforeDetail);
          let path = 'pages/detail/detail';
          let imgpath = encodeURIComponent(this.goodsDetail.mainImage);
          let title = this.goodsDetail ? encodeURIComponent(this.goodsDetail.itemFullName) : "";
          let url = `../share/share?path=${path}&title=${title}&img=${imgpath}&goodsId=${this.saleSkuId}&retailPrice=${this.goodsDetail.salePrice}&marketPrice=${this.goodsDetail.marketPrice}&beforeDetail=${this.beforeDetail}`
          this.$wx.miniProgram.navigateTo({
            url: url,
          })
        }else{
          let fullPath = this.$route.fullPath;
          let path = `/pages/detail/detail`
          this.$wx.miniProgram.redirectTo({
            url: "/pages/login/login?pagefrom="+path+"&"+fullPath.split('?')[1]
          })
        }

      },
      // 直接购买
      goOrderConfirm:async function(isBuy){
        if(!isBuy){
          this.showGoodspe = true;
          this.isShopBtn = true
          this.popType = "shop"
          return
        }
        try{
          const res = await this.$service.shopclearCache();
          
          if(res.result){
            let params = {
              // saleCategoryId: saleCategoryId,
              urlstr:"orderConfirm",
              type:'newUser',
              itemId:this.goodsDetail.itemId,
              num:this.payNum
            }
            this.$navigateTo("orderConfirm",params)
          }else{
            this.$toast("系统出错，请稍后重试")
          }
        }catch(e){
          // 未登录会直接跳转登录页面，无需提示
          if(e.status != '401' &&  e.status != '403' ) this.$toast('系统出错，请稍后重试')
        }
        
      },
      // 倒计时结束触发
      ftime:function(t){
        console.log(this[t],t)
        this[t] = 0
      }
    }
}
</script>
<style lang="less" src="@/style/detail.less"></style>